import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Icon from "../Icon";
import Header from "../main/Header";
import MobilMenu from "../mobil-menu/MobilMenu";
import { FormattedMessage, useIntl } from 'react-intl';

const Archivum = ({ main, toogleMode, mode }) => {
    const intl = useIntl();

    const archive_title = intl.formatMessage({ id: 'archive_title', defaultMessage: 'Archívum' });

    let { name } = useParams();

    const [theme, setTheme] = useState(null);
    const [selectedCategor, setSelectedCategor] = useState(null);

    /* eslint-disable */
    useEffect(() => {
        if (main.sections) {
            const findedTheme = main.sections.find(m => m.url === name);
            if (findedTheme) {
                setTheme(findedTheme)
                const productItemId = findedTheme.guid;
                const productInfo = `${archive_title}: ${findedTheme.title} - ${window.location.href}`
                window.feedback.productItemId = productItemId;
                window.feedback.productInfo = productInfo;
            }
        }
    }, [main])



    return (<><div className={theme ? theme.url : "notheme"}>
        {theme && <Header categor={null} theme={theme} toogleMode={toogleMode} mode={mode} />}
        <Container fluid className="archivum">
            <Row className="justify-content-md-center g-0">
                <Col md={{ span: 11, offset: 1}} sm={12}>
                    <h1 className="publication-title"><Icon icon={"archive-fill"} className={mode !== "dark" ? "" : "gray"} /> <FormattedMessage id="archive_title" defaultMessage="Archívum" /></h1>

                    <Row>
                        <Col sm={6} md={5} xs={12} >

                            {theme && theme.categories.map((categor, key) =>
                                <div
                                    className={`archive-item`}
                                    onMouseOver={() => setSelectedCategor(categor)}
                                    onMouseLeave={() => setSelectedCategor(null)}
                                >
                                    <a href={categor.archivumlink} target="_blank" rel="noreferrer" className={`${mode === "dark" && selectedCategor === categor && "theme-color"}`} >
                                        <Icon icon={categor.icon} className={mode !== "dark" ? (selectedCategor === categor ? "blue" : "") : (selectedCategor === categor ? "theme-color" : "gray")} /> <span>{categor.title}</span>
                                        {selectedCategor && selectedCategor === categor && <>
                                            <Icon icon="arrow-right" className={(mode !== "dark" ? (selectedCategor === categor ? "blue" : "") : (selectedCategor === categor ? "theme-color" : "gray")) + " categor-arrow-right"} />
                                        </>}
                                    </a>
                                </div>

                            )}
                        </Col>

                        <Col sm={6} md={7} xs={12}
                        ><img className="archive-img" alt="" src={`assets/${mode === "dark" ? "dark" : "light"}-archive.svg`} /></Col>
                    </Row>
                </Col>
            </Row>
        </Container>

    </div>
        <button class="feedback-button button" onClick={() => window.feedback.show()}><Icon icon={"feedback"} /> <FormattedMessage id="feedback" defaultMessage="Visszajelzés" /></button>
        <MobilMenu mode={mode} toogleMode={toogleMode} isArchive={true} />
        </>
    )
}

export default Archivum;
